import ExhibitionEmpty from "./exhibition-empty";

export default ExhibitionEmpty;